import { ApprovalApproverKind } from '../../../Enums/approval-types.enum';
import { ApprovalApprover } from '../../../Interfaces/api/catalog/approval-approver.interface';

export interface ApprovalApproverDisplay {
  approverName: string | null;
  groupName: string | null;
  typeKey: string | null;
}

export function resolveApprovalApproverDisplay(
  approver: ApprovalApprover,
  type: string,
): ApprovalApproverDisplay {
  if (approver.kind === ApprovalApproverKind.Unresolved) {
    return {
      approverName: null,
      groupName: null,
      typeKey: `app.catalog.demand.workflow.types.${type}`,
    };
  }

  if (approver.kind === ApprovalApproverKind.Group) {
    return {
      approverName: null,
      groupName: approver.group_name?.trim() || approver.display_name.trim(),
      typeKey: null,
    };
  }

  return { approverName: approver.display_name.trim(), groupName: null, typeKey: null };
}
